import { LAYOUT_BO } from "@/constants";
import { LazyLoadComponentWrapper } from "@/utils/lazy-load-component-wrapper";
import { ifAuthenticated } from "@/utils/auth";
import PassThrough from "@/views/pass-through";

const commentRouter = {
  path: "comment",
  component: PassThrough,
  beforeEnter: ifAuthenticated,
  meta: {
    layout: LAYOUT_BO,
    menuTitleTransCode: "COMMENT",
    menuIcon: "icon-route-comment",
    allowedRoles: ["ADMIN", "MANAGER", "OFFICER"]
  },
  children: [
    {
      path: "",
      component: () => LazyLoadComponentWrapper(import("@/views/bo/comment/list.vue")),
      meta: {
        layout: LAYOUT_BO,
        breadcrumbTransCodeList: ["COMMENT_MANAGEMENT"],
      },
    },
    {
      path: "detail/:id(\\d+)?",
      component: () => LazyLoadComponentWrapper(import("@/views/bo/comment/detail.vue")),
      meta: {
        layout: LAYOUT_BO,
        breadcrumbTransCodeList: ["COMMENT_MANAGEMENT", "COMMENT_DETAIL"],
      },
    }
  ]
};

export default commentRouter;
